import { Trans } from "@lingui/react/macro";
import { Box, Flex } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import CreateCustomer from "@/features/customers/create-customer/create-customer";
import CustomersTable from "@/features/customers/customers-table";
import { Can } from "@/shared/providers/casl-provider";

export const Route = createFileRoute("/_app/(multi-location)/admin/customers/")(
  {
    component: () => <CustomersPage />,
  },
);

function CustomersPage() {
  return (
    <Box p="lg">
      <Flex align="center" justify="space-between">
        <h1>
          <Trans>Kunderegister</Trans>
        </h1>

        <Can I="create" a="Customer">
          <CreateCustomer />
        </Can>
      </Flex>

      <CustomersTable />
    </Box>
  );
}
